import HeaderForm from "../../../../../components/headerForm";
import quantidade from "../../../../../helpers/QuantidadeFormularios";
import Form from "../../../../../components/form/Form";
import Button from "../../../../../components/button/Button";
import React, {useEffect, useState} from "react";
import InputSelect from "../../../../../components/input/InputSelect";
import saudeHistoricoImigracionalApi from "../../../../../services/saudeHistoricoImigracionalApi";
import Alert from "../../../../../helpers/Alert";
import processosApi from "../../../../../services/processosApi";
import perguntaSegurancaApi from "../../../../../services/perguntaSegurancaApi";

export interface IPerguntaSegurancaCa{
    processo?: any;
    setProcesso?: any;
    setTelaNumero?: any;
    telanumero?: any;
}

export default function PerguntaSegurancaCa({processo, setProcesso, setTelaNumero, telanumero}: IPerguntaSegurancaCa) {
    const [state, setState] = useState({
        id: '',
        processo_id: processo.id,
        caso_envolvido: 'crimes',
        informacao: ''
    });
    const casosEnvolvidosOptions = [
        { value: 'crimes', label: 'Já foi preso(a) ou acusado(a) por qualquer crime em qualquer país?' },
        { value: 'exercito', label: 'Já fez parte do exército, milícia, polícia ou unidade de defesa?' },
        { value: 'governo', label: 'Já trabalhou no governo em alguma área relacionada à segurança?' },
        { value: 'posicao_politica', label: 'Já ocupou posição de autoridade no governo, judiciário ou partido político?' },
        { value: 'crimes_guerra', label: 'Em tempos de paz ou guerra, esteve envolvido em crimes que lesa a humanidade?' },
        { value: 'nao', label: 'Não se aplica.' },
    ];
    const getData = async () => {
        const {data, isError} = await perguntaSegurancaApi.one(processo.id);
        if (!isError){
            if (Object.values(data.data).length){
                const response = data.data;
                setState(response);
            }
        }
    }

    useEffect(() => {
        getData()
    }, []);
    const onSubmit = async () => {
        Alert.await("Salvando dados");
        const {data, isError} = state.id ? await perguntaSegurancaApi.update(state.id, state) : await perguntaSegurancaApi.create(state);
        if (isError){

            if (typeof data === 'object') {
                Object.keys(data.errors).forEach(function(key, index) {
                    Alert.error(data.errors[key][0]);
                });
                return;
            }
            return Alert.error(data.data.message? data.data.message : data.data);
        }

        if (!state.id){
            const percent = (telanumero * 100) / quantidade[processo.tipo_visto_id];
            await processosApi.update(processo.id, {percet_conclusao: percent})
            setProcesso({...processo, ['percet_conclusao']: percent})
        }
        Alert.close();
        window.scrollTo(0, 0);
        setTelaNumero(telanumero + 1);
    }
    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };
    return(
        <>
            <HeaderForm
                titulo={'Pergunta de segurança'}
                numeroPaginalAtual={telanumero}
                numeroTotal={quantidade[processo.tipo_visto_id]}
                percentual={processo.percet_conclusao}
            />
            <Form  onSubmit={() => onSubmit()}>
                <div className={'p-5'}>
                    <div className={'md:col-span-3'}>
                        <InputSelect
                            label={"Clique no item, caso ele se aplique ao seu caso"}
                            selected={casosEnvolvidosOptions.filter((opt: any) => opt.value === state.caso_envolvido)}
                            options={casosEnvolvidosOptions}
                            onChangeSelect={(e: any) => setState({...state, ['caso_envolvido']: e.value})}
                        />
                    </div>
                    <div className={'grid  md:grid-cols-3 gap-4 mt-5'}>
                        <div className={'col-span-2 mt-3 flex flex-col'}>
                            <label
                                className="font-medium"
                            >
                                Caso tenha se envolvido em qualquer uma das questões acima, explique
                            </label>
                            <textarea
                                className={'bg-light border border-border rounded-md outline-none p-2  w-full'}
                                rows={5}
                                cols={50}
                                name={'informacao'}
                                onChange={e => handleChange(e.target.value,'informacao')}
                                value={state.informacao ? state.informacao : ""}
                            />
                        </div>
                    </div>
                </div>
                <div className={'border-2'}></div>
                <div className={'flex justify-between p-5'}>
                    <Button
                        onClick={() => setTelaNumero(telanumero - 1)}
                        className={'w-[164px] h-[48px] bg-white text-gray-800 border border-gray-500 font-semibold'}
                    >
                        Voltar
                    </Button>
                    <Button
                        type={'submit'}
                        className={'w-[164px] h-[48px] bg-[#082a60] text-white font-semibold'}
                    >
                        Continuar
                    </Button>
                </div>
            </Form>
        </>
    )
}